import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { type FC } from 'react';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import { StripeLogoIcon } from '../../../../../../../components/logo-icons';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { StripeRegisterControl } from '../StripeRegisterFormSchema';

interface StripeRegistrationFormProps {
  control: StripeRegisterControl;
}

export const StripeRegistrationForm: FC<StripeRegistrationFormProps> = ({ control }) => (
  <FormContainer {...getSelectorAttribute(integrationsPageSelectors.drawer.stripe.apiTokenInput)}>
    <StripeLogoIcon />
    <Typography variant="h4">Enter your stripe key to get started</Typography>
    <ControlledTextInput
      name="apiToken"
      control={control}
      label="API Key"
      placeholder="Enter API Key here..."
      defaultValue=""
    />
    <Typography
      variant="subtitle2"
      sx={{ color: '#3A78F8', cursor: 'pointer' }}
      onClick={() => window.open('https://docs.stripe.com/connect/design-an-integration')}
    >
      Where can I find my key?
    </Typography>
  </FormContainer>
);

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
